import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type SOPMappingToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
};

export function SOPMappingToolbar({
  canManage,
  onCreate,
}: SOPMappingToolbarProps) {
  return (
    <div className="mb-4 flex items-center justify-between">
      <h1 className="font-bold text-2xl">ການຜູກ SOP ກັບຕໍາແໜ່ງ</h1>
      {canManage && (
        <Button onClick={onCreate}>
          <PlusIcon className="mr-2 h-4 w-4" />
          ສ້າງການຜູກໃໝ່
        </Button>
      )}
    </div>
  );
}
